// This file is auto-generated

import deDE from './baurde/de-DE.json';

const messages = { 'de-DE': deDE };

export default messages;
